import { Breadcrumb,Button,Input,Modal,Popconfirm,message,Select,Form,Space,InputNumber,Spin } from "antd"
import { Link } from "react-router-dom"
import {MdOutlineLibraryBooks} from "react-icons/md";
import Header from "../../components/dashboard/header";
import { DashboardOutlined,PlusSquareOutlined,EditOutlined,DeleteOutlined } from "@ant-design/icons";
import {AiOutlineSetting} from "react-icons/ai"
import {useContext, useRef, useState,useEffect} from "react";
import DataTable from "../../components/common/table";
import { useCreateBudgetApproval, useDeleteBudgetApprovalStage, useFetchBudgetApprovalStages, useUpdateBudgetApprovalStage } from "../../hooks/budgetApproval/budgetApproval";
import {useRoles} from "../../hooks/roles/rolesQuery";
import { extractValueFromInputRef,scrollToTop } from "../../helpers/dom";
import RefreshContext from "../../context/refreshContext";

const {Option} =  Select;


const approvalRolesColumns = [
    {
        title:"S/N",
        key:"s/n",
        render:(_,__,idx)=>idx+1
    },
    {
        title:"Role",
        dataIndex:"title",
        key:"title",
    },
    {
        title:"Priority",
        dataIndex:"approvalOrder",
        key:"priority"
    },
    {
        title:"Actions",
        key:"actions",
        render:(_,role)=> <BudgetApprovalStageEdit role={role}/>
    }
];


function BudgetApprovalStageEdit({role}){
    const [isOpen,setIsOpen] = useState(false);
    const [r,setR] = useState("");
    const handleOpen = ()=> setIsOpen(true);
    const handleClose =()=> setIsOpen(false);
    const {flag,setFlag} = useContext(RefreshContext);


    const deleteBudgetApprovalStage = useDeleteBudgetApprovalStage();
    const updateBudgetApprovalStage = useUpdateBudgetApprovalStage();
    const orderRef = useRef(null);
    const titleRef = useRef(null);

    const roles = useRoles();

    const handleSubmit = async()=>{
        const payload = {
            title:extractValueFromInputRef(titleRef),
            approvalOrder: orderRef.current.value,
            role:r
        }
        const {message:response} = await updateBudgetApprovalStage(role.id,payload);
        message.success(response??"approval stage updated successfully");
        setFlag(!flag);
        setIsOpen(false);
    }

    const confirmDelete = async()=>{
        const {message:response} = await deleteBudgetApprovalStage(role.id);
        message.success(response??"approval stage deleted successfully");
        setFlag(!flag);
        return;
    }

    return(
        <>
             <Space size="small" wrap>
                <Button type="primary" onClick={handleOpen}>
                <EditOutlined />
                    Edit
                </Button>
                <Popconfirm
                     title="Delete this Role"
                     description="Are you sure to delete this role?"
                     onConfirm={confirmDelete}
                    onCancel={()=>null}
                    okText="Yes"
                    cancelText="No"
                     >
                    <Button type="primary" danger>
                        <DeleteOutlined />
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
            <Modal title={'Edit approval role'} footer={null} open={isOpen} onCancel={handleClose}>
                <Form initialValues={{...role}}>
                    <Form.Item name="title">
                        <Input placeholder="title" ref={titleRef} />
                    </Form.Item>
                    <Form.Item name="role">
                    <Select placeholder="select a role" onChange={(e)=>setR(e)}>
                            {
                                roles.map((r,idx)=>(
                                    <Option value={r.name} key={idx}>{(r.name).toLowerCase()}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                    <Space>
                    <Form.Item name="priority">
                        <InputNumber style={{width:'100%'}} placeholder="enter role priority" ref={orderRef}/>
                    </Form.Item>
                        <Form.Item name="active">
                            <Select style={{width:"20em"}} placeholder={"select role active status"}>
                                <Option value={true}>Active</Option>
                                <Option value={false}>Not Active</Option>
                            </Select>
                        </Form.Item>
                    </Space>
                    <Form.Item
                               wrapperCol={{
                                span:8,
                                offset:20
                              }}
                              className="submit-button-wrapper"
                            >
                              <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                                Submit
                              </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}



export default function BudgetApproval(){
    const [r,setR] = useState("");
    const [isOpen,setIsOpen] = useState(false);
    const {flag,setFlag} = useContext(RefreshContext);


    const handleOpen = ()=> setIsOpen(true);
    const handleClose = ()=> setIsOpen(false);


    const orderRef = useRef(null);
    const titleRef = useRef(null);
    const roles = useRoles(flag);
    const {loading,budgetApprovals:budgetApprovalStages} = useFetchBudgetApprovalStages(flag);
    const createApprovalStage = useCreateBudgetApproval();

    
    useEffect(()=>{
        scrollToTop();
    },[]);
  

    const handleSubmit = async ()=>{
        const payload = {
            title:extractValueFromInputRef(titleRef),
            approvalOrder: orderRef.current.value,
            role:r,
        }
        const {message:response} = await createApprovalStage(payload);
        message.success(response??"role added successfully");
        setIsOpen(false);
        setFlag(!flag);
    }

    return(
        <>
            
            <div className="main-container">
                <Header/>
                <div className="main-body">
                    
                    <div className="info-bar">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                        <DashboardOutlined className="dashboard-icon"/>
                        <Link to={"/dashboard"}>Dashboard</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                        <AiOutlineSetting/> 
                        <Link to={"/dashboard"}>Configuration</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <MdOutlineLibraryBooks/>
                            <Link to="/dashboard/voucher-approval">Budget Approval Setting</Link>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{display:'flex',gap:'1em'}}>
                            <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={handleOpen}>
                            <PlusSquareOutlined />
                                Add Role
                            </Button>
                        </div>
                    </div>
                    
                    <div className="table-section">
                        <Spin spinning={loading}>
                        <DataTable cols={approvalRolesColumns} data={budgetApprovalStages}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal title="Create Approval Role" footer={null} open={isOpen} onCancel={handleClose}>
                <Form>
                <Form.Item name="title">
                        <Input placeholder="title" ref={titleRef} />
                    </Form.Item>
                    <Form.Item>
                        <Select placeholder="select a role" onChange={(e)=>setR(e)}>
                            {
                                roles.map((r,idx)=>(
                                    <Option value={r.value} key={idx}>{(r.name).toLowerCase()}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                    <Space>
                    <Form.Item name="priority">
                        <InputNumber style={{width:'100%'}} ref={orderRef} placeholder="enter role priority"/>
                    </Form.Item>
                        <Form.Item name="active">
                            <Select style={{width:"20em"}} placeholder={"select role active status"}>
                                <Option value={true}>Active</Option>
                                <Option value={false}>Not Active</Option>
                            </Select>
                        </Form.Item>
                    </Space>
                    <Form.Item
                               wrapperCol={{
                                span:8,
                                offset:20
                              }}
                              className="submit-button-wrapper"
                            >
                              <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                                Create
                              </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}